// src/store/useCountdownStore.ts
import { create } from "zustand";

type CountdownState = {
  secondsLeft: number;
  isActive: boolean;
  targetPath: string | null;
  startCountdown: (seconds: number, targetPath: string) => void;
  stopCountdown: () => void;
  tick: () => void;
};

export const useCountdownStore = create<CountdownState>((set) => ({
  secondsLeft: 0,
  isActive: false,
  targetPath: null,
  startCountdown: (seconds, targetPath) =>
    set({
      secondsLeft: seconds,
      isActive: true,
      targetPath,
    }),
  stopCountdown: () =>
    set({
      secondsLeft: 0,
      isActive: false,
      targetPath: null,
    }),
  tick: () =>
    set((state) =>
      state.secondsLeft > 0
        ? { secondsLeft: state.secondsLeft - 1 }
        : { ...state, isActive: false }
    ),
}));
